<template>
<div class="content has-text-centered">

  <div class="columns is-vcentered">
    <div class="column is-6 is-offset-3">
      <div class="box">
        <form v-on:submit.prevent="login">
          <label class="label">Email</label>
          <p class="control">
            <input v-model="data.body.username" class="input" type="text" placeholder="email@example.org">
          </p>
          <label class="label">Password</label>
          <p class="control">
            <input v-model="data.body.password" class="input" type="password" placeholder="password">
          </p>

          <!--<p class="control">-->
            <!--<label class="checkbox">-->
              <!--<input type="checkbox" v-model="data.rememberMe">-->
              <!--Remember me-->
            <!--</label>-->
          <!--</p>-->

          <hr>
          <p class="control">
            <button type="submit" class="button is-primary">Войти</button>
            <a v-if="canSignUp" href="#/sign-up" class="button is-success">
              <span>Зарегистрироваться</span>
            </a>
          </p>
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import Notification from 'vue-bulma-notification'
  import AuthCommon from './AuthCommon'

  const AUTH_API = '/api/auth'
  const APPCONFIG_API = '/api/appConfig'

  export default {
    components: {
      Notification
    },
    extends: AuthCommon,
    data() {
      return {
        data: {
          body: {
            username: null,
            password: null
          },
          rememberMe: false
        },
        canSignUp: true
      }
    },
    created: function () {
      this.loadAppConfig()
    },
    mounted() {
      // if (this.$auth.redirect()) {
      //   console.log('Redirect from: ' + this.$auth.redirect().from.name)
      // }
      // Can set query parameter here for auth redirect or just do it silently in login redirect.
    },
    methods: {
        login() {
          this.$http.post(AUTH_API + '/sign-in', this.data.body)
            .then((response) => {
              this.openNotificationWithType('success', 'Осуществлен вход ' + this.data.body.username)
              this.loginCallback(response)
              this.$router.push('/scenarios')
            })
            .catch((error) => {
              this.openNotificationWithType('danger', 'Ошибка авторизации')
              console.log(error)
            })
        },
      loadAppConfig () {
        this.$http.get(APPCONFIG_API, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.appconfig = response.data
            this.canSignUp = this.appconfig.userCanSignUp
          })
          .catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ')
          })
      }
    }
  }

</script>

<style lang="scss" scoped>
.is-title {
    text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// Login.vue?1a5a1438